import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { InstitusionContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const SaleStatus1 = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.instituson;
  const contract = InstitusionContract(tokenAddress, web3);

  const saleStatus1 = useCallback(async () => {
    try {
      const buy = await contract.methods.buyEnable().call();
      return buy;
    } catch (error) {
      throw error;
    }
  }, [contract, account, web3]);
  return { saleStatus1: saleStatus1 };
};
export default SaleStatus1;
